"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _rcPagination = _interopRequireDefault(require("rc-pagination"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _Pagination = require("./Pagination.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Menu = _Dropdown["default"].Menu,
    Button = _Dropdown["default"].Button;

var itemRender = function itemRender(current, type, element) {
  if (type === 'page') {
    return (0, _jsxRuntime.jsx)("button", {
      type: "button",
      className: "grui",
      css: _elements.button.styles.preflight,
      children: current
    });
  }

  return element;
};

var getIconsProps = function getIconsProps(simple) {
  var ellipsis = (0, _jsxRuntime.jsx)("div", {
    css: _elements.text.styles.textXs,
    children: "\u2026"
  });
  var prevIcon = (0, _jsxRuntime.jsx)("button", {
    className: "grui",
    css: [_elements.button.styles.preflight, _Pagination.styles.prev, process.env.NODE_ENV === "production" ? "" : ";label:prevIcon;"],
    type: "button",
    tabIndex: -1,
    children: simple ? (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)(_icons.ChevronRight, {}), (0, _jsxRuntime.jsx)("span", {
        children: "Previous"
      })]
    }) : (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})
  });
  var nextIcon = (0, _jsxRuntime.jsx)("button", {
    className: "grui",
    css: [_elements.button.styles.preflight, _Pagination.styles.next, process.env.NODE_ENV === "production" ? "" : ";label:nextIcon;"],
    type: "button",
    tabIndex: -1,
    children: simple ? (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)("span", {
        children: "Next"
      }), (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})]
    }) : (0, _jsxRuntime.jsx)(_icons.ChevronRight, {})
  });
  var jumpPrevIcon = (0, _jsxRuntime.jsx)("button", {
    className: "grui",
    css: _elements.button.styles.preflight,
    type: "button",
    tabIndex: -1,
    children: ellipsis
  });
  var jumpNextIcon = (0, _jsxRuntime.jsx)("button", {
    className: "grui",
    css: _elements.button.styles.preflight,
    type: "button",
    tabIndex: -1,
    children: ellipsis
  });
  return {
    prevIcon: prevIcon,
    nextIcon: nextIcon,
    jumpPrevIcon: jumpPrevIcon,
    jumpNextIcon: jumpNextIcon
  };
};

var menu = function menu(data) {
  return (0, _jsxRuntime.jsx)(Menu, {
    children: data.map(function (item) {
      return (0, _jsxRuntime.jsx)(Menu.Item, {
        itemKey: item,
        children: item
      }, item);
    })
  });
};

var getCurrentItemsCount = function getCurrentItemsCount(current, pageSize, total, simple) {
  if (simple) {
    return "Showing ".concat(total, " results");
  }

  var lastOne = current * pageSize > total ? total : current * pageSize;
  return "Showing ".concat((current - 1) * pageSize + 1, "-").concat(lastOne, " of ").concat(total);
};

var Pagination = function Pagination(_ref) {
  var total = _ref.total,
      pageSize = _ref.pageSize,
      current = _ref.current,
      onChange = _ref.onChange,
      className = _ref.className,
      showSizeChanger = _ref.showSizeChanger,
      pageSizeOptions = _ref.pageSizeOptions,
      setPageSize = _ref.setPageSize,
      showLessItems = _ref.showLessItems,
      disabled = _ref.disabled,
      simple = _ref.simple,
      hideItemsCount = _ref.hideItemsCount;

  var _useState = (0, _react.useState)(pageSize),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectedValue = _useState2[0],
      setSelectedValue = _useState2[1]; // Pagination page start from 1 instead of 0


  var currentPage = current; // Only show pagination controls when the total is larger than the page size option

  var showPageControls = selectedValue < total;
  var simpleWithoutItemsCount = hideItemsCount && simple;
  var handleSelect = (0, _react.useCallback)(function (key) {
    setSelectedValue(key);
    setPageSize(Number(key));
  }, [setPageSize]);
  var sizeChanger = (0, _jsxRuntime.jsxs)("div", {
    css: _Pagination.styles.sizeChanger,
    children: ["Rows per page:\xA0", (0, _jsxRuntime.jsx)(_Dropdown["default"], {
      overlay: menu(pageSizeOptions),
      onSelect: handleSelect,
      selectedKey: selectedValue,
      css: _Pagination.styles.dropdown,
      disabled: disabled,
      children: (0, _jsxRuntime.jsx)(Button, {
        size: "small",
        textBtn: true,
        css: _elements.text.styles.textDark,
        children: (0, _jsxRuntime.jsx)("span", {
          children: selectedValue
        })
      })
    })]
  });
  var handleChangePage = (0, _react.useCallback)(function (value) {
    onChange(value);
  }, [onChange]);
  return (0, _jsxRuntime.jsxs)("div", {
    className: (0, _clsx["default"])('grui flex items-center justify-between', className),
    css: [_elements.text.styles.textDark, _Pagination.styles.container, process.env.NODE_ENV === "production" ? "" : ";label:Pagination;"],
    children: [showSizeChanger && sizeChanger, showPageControls && (0, _jsxRuntime.jsx)(_rcPagination["default"], _objectSpread(_objectSpread({
      css: [_Pagination.styles.pagination, simpleWithoutItemsCount && _Pagination.styles.simpleWithoutItemsCount, process.env.NODE_ENV === "production" ? "" : ";label:Pagination;"],
      total: total,
      current: currentPage,
      onChange: handleChangePage,
      pageSize: pageSize,
      locale: "enUS",
      prefixCls: "pagination",
      showLessItems: showLessItems,
      disabled: disabled,
      simple: simple
    }, getIconsProps(simple)), {}, {
      itemRender: itemRender
    })), !hideItemsCount && showSizeChanger && (0, _jsxRuntime.jsx)("div", {
      children: getCurrentItemsCount(currentPage, pageSize, total, simple)
    })]
  });
};

Pagination.propTypes = {
  total: _propTypes.number.isRequired,
  current: _propTypes.number.isRequired,
  onChange: _propTypes.func.isRequired,

  /**
   * items per page
   */
  pageSize: _propTypes.number,
  className: _propTypes.string,

  /**
   * Wheter to show sizeChanger,
   * if true, will show items count too
   */
  showSizeChanger: _propTypes.bool,

  /**
   * specify the sizeChanger options
   */
  pageSizeOptions: (0, _propTypes.arrayOf)(_propTypes.number),
  setPageSize: _propTypes.func,

  /**
   * show less page items
   */
  showLessItems: _propTypes.bool,
  disabled: _propTypes.bool,

  /**
   * Whether to use simple mode
   */
  simple: _propTypes.bool,

  /**
   * Whether to hide items count info,
   * will move the pagination (navigation part) to the left too if simple is also true
   */
  hideItemsCount: _propTypes.bool
};
Pagination.defaultProps = {
  pageSize: 10,
  className: undefined,
  showSizeChanger: false,
  pageSizeOptions: [10, 20, 30, 40, 50],
  setPageSize: function setPageSize() {},
  showLessItems: false,
  disabled: false,
  simple: false,
  hideItemsCount: false
};
var _default = Pagination;
exports["default"] = _default;
//# sourceMappingURL=Pagination.js.map